export const CURR_USER_BOOTSTRAP = 'bootstrap/currUser';
